/*doc

 Renders a footer that contains the like count, the like/unlike action button,
 and a comment button that displays the comment form and/or list of comments
 when clicked

 */

import React from "react";
import GrComponentFactory from "../gr_component_factory";
import GrPropTypes from "../shared/gr_prop_types";
import LikeSimpleFooter from "./like_simple_footer";
import DotSeparatedElements from "../dot_separated_elements";
import Comments from "../comment/comments";
import CommentForm from "../comment/comment_form";
import CommentsStore from "../../react_stores/comments_store";
import { connectToLazyStore } from "../../react_mixins/gr_reflux";

export default GrComponentFactory.createClass({
  displayName: "LikesAndCommentsFooter",
  mixins: [connectToLazyStore(CommentsStore, "comment.subjectKey")],
  propTypes: {
    currentUser: GrPropTypes.user().isRequired,
    resourceKey: React.PropTypes.string.isRequired,
    resourceLabel: React.PropTypes.string.isRequired,
    isLikeable: React.PropTypes.bool.isRequired,
    showAsLink: React.PropTypes.bool,
    comment: GrPropTypes.comment().isRequired,
  },
  getInitialState(){
    return {
      showCommentForm: false,
      showCommentList: false,
    };
  },
  getSimpleFooter(){
    return <LikeSimpleFooter resourceKey={this.props.resourceKey}
                             resourceLabel={this.props.resourceLabel}
                             showAsLink={this.props.showAsLink}
                             isLikeable={this.props.isLikeable}/>;
  },
  isCommentListShown(){
    return this.state.showCommentList;
  },
  isCommentFormShown(){
    return this.state.showCommentForm;
  },
  toggleCommentFormDisplayStatus(){
    this.setState({ showCommentList: !this.isCommentListShown() });
    if (this.props.comment.canComment){
      this.setState({ showCommentForm: !this.isCommentFormShown() });
    }
  },
  //
  // Creates array of footer elements
  //
  getFooterElements(){
    const elements = [];
    let buttonText = this.state.numComments > 1 ? "Comments" : "Comment";
    elements.push(this.getSimpleFooter());
    //
    // We want to show the comments button...
    // 1. If the resource is commentable AND there are comments associated with it
    // 2. OR the user themself can comment on the resource
    //
    const commentsToShow = (this.props.comment.commentable && (this.state.numComments > 0));
    if (commentsToShow || this.props.comment.canComment) {
      //
      //update button text to reflect number of comments
      //
      if (this.state.numComments > 0){
        buttonText = `${this.state.numComments} ${buttonText}`;
      }
      elements.push(
        <button className="gr-buttonAsLink"
                onClick={this.toggleCommentFormDisplayStatus}>
          {buttonText}
        </button>
      );
    }
    return elements;
  },

  render() {
    return (
      <div>
        <div>
          <DotSeparatedElements elements={this.getFooterElements()} />
        </div>
        {
          this.state.showCommentList ?
            <Comments
              subjectKey={this.props.comment.subjectKey}
              subjectUrl={this.props.comment.subjectUrl}
              subject={this.props.comment.subject}
              bemModifiers="whiteBackgroundNormalWidth"
            /> : null
        }
        {  this.state.showCommentForm ?
            <CommentForm
              subjectKey={this.props.comment.subjectKey}
              subject={this.props.comment.subject}
              authorUser={this.props.currentUser}
              bemModifiers="whiteBackground"
            /> : null
        }
      </div>
    );
  },
});
